import { render, staticRenderFns } from "./SmallStats.vue?vue&type=template&id=1322babc&scoped=true"
import script from "./SmallStats.vue?vue&type=script&lang=js"
export * from "./SmallStats.vue?vue&type=script&lang=js"
import style0 from "./SmallStats.vue?vue&type=style&index=0&id=1322babc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322babc",
  null
  
)

export default component.exports